// Auto-generated from proto definitions. DO NOT EDIT.

export type AuthMethodType = 'AUTH_METHOD_TYPE_UNSPECIFIED' | 'AUTH_METHOD_TYPE_LOCAL' | 'AUTH_METHOD_TYPE_LDAP' | 'AUTH_METHOD_TYPE_SAML' | 'AUTH_METHOD_TYPE_OIDC';

export const AuthMethodTypeValues = ['AUTH_METHOD_TYPE_UNSPECIFIED', 'AUTH_METHOD_TYPE_LOCAL', 'AUTH_METHOD_TYPE_LDAP', 'AUTH_METHOD_TYPE_SAML', 'AUTH_METHOD_TYPE_OIDC'] as const;
